import { Cat, Dog } from 'lucide-react';

// A playful pet face "hiding" behind the edge of a card or headline,
// peeking out over the border. Purely decorative.
export const PetPeek = ({ type = 'cat', className = '' }) => {
  const Icon = type === 'dog' ? Dog : Cat;
  return (
    <div
      data-testid={`pet-peek-${type}`}
      aria-hidden="true"
      className={`pointer-events-auto absolute z-20 transition-transform duration-500 ease-out hover:-translate-y-2 hover:rotate-6 ${className}`}
    >
      <div
        className={`w-12 h-12 rounded-full flex items-center justify-center border-4 shadow-lg ${
          type === 'dog'
            ? 'bg-brand-green text-brand-citrus border-brand-cream'
            : 'bg-brand-orange text-white border-brand-cream'
        }`}
      >
        <Icon className="w-6 h-6" />
      </div>
    </div>
  );
};
